import React from 'react';
import { PatientManualRegistrationParams } from '../PatientManualRegistration';
import useWorkplacePatient, {
	PatientData,
} from '../../../Hooks/useWorkplacePatient';
import { useLazyUserParentsQuery } from '../../../../../graphql/graphql';
import useFilters from '../../../../Base/Hooks/useFilters';
import useHelpers from '../../../../Base/Hooks/useHelpers';
import PatientManualRegistrationSloveniaForm, {
	PatientManualRegistrationSloveniaFormValues,
} from './PatientManualRegistrationSloveniaForm';

interface Props {
	workplaceId: string;
	onSuccess?: (params: PatientManualRegistrationParams) => void;
	setIsLoading: (isLoading: boolean) => void;
}

const PatientManualRegistrationSlovenia: React.FC<Props> = ({
	workplaceId,
	onSuccess,
	setIsLoading,
}) => {
	const { createPatient } = useWorkplacePatient();
	const [getParents] = useLazyUserParentsQuery();
	const { handleDateValue } = useFilters();
	const { handleString } = useHelpers();

	const handleSloveniaRegistrationSuccess = async (
		values: PatientManualRegistrationSloveniaFormValues,
	) => {
		setIsLoading(true);
		const data: PatientData = {
			sendEmailInvitation: values.sendPatientInviteToMeddi,
			patient: {
				salutationBefore: values.salutationBefore ?? undefined,
				salutationAfter: values.salutationAfter ?? undefined,
				firstName: values.firstName,
				lastName: values.lastName,
				address: values.address,
				contactPhoneNumber: values.phoneNumber ?? undefined,
				contactEmail: values.email,
				emso: values.emso,
				birthDate: handleDateValue(values.birthDate),
				citizenship: handleString(values.citizenship?.value),
				gender: handleString(values.gender?.value),
			},
			legalRepresentative: values.legalRepresentative ?? undefined,
			createdByType: handleString(values.createdByType?.value),
			createdById: values.createdById?.item?.user.id ?? undefined,
		};

		const patient: any = await createPatient(data, workplaceId);
		if (patient) {
			let parentId = null;
			if (data.legalRepresentative) {
				const data = await getParents({
					id: patient.data.userId,
				});
				if (data.data?.user?.parents?.[0]?.id) {
					parentId = data.data?.user?.parents?.[0].id;
				}
			}
			onSuccess?.({
				patientId: patient.data.userId,
				parentId: parentId,
				withInvite: data.sendEmailInvitation,
			});
		}
		setIsLoading(false);
	};

	return (
		<PatientManualRegistrationSloveniaForm
			onSuccess={handleSloveniaRegistrationSuccess}
		/>
	);
};

export default PatientManualRegistrationSlovenia;
